import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ResourcesLoaderService, ADPResourceService } from 'digital-core';
import { PGHAppLoadService } from 'src/app/core/core';

@Injectable({
  providedIn: 'root'
})
export class PageResourcesResolver  {
  firstLoad = true;
  constructor(
    private loadService: PGHAppLoadService,
    private resourcesLoader: ResourcesLoaderService,
    public resourceService: ADPResourceService,
  ) { }

  uriOrigin: string;

  async resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
    let components = route.data['sfresources'];
    if (!components) {
      //throw new Error(`There is no Components associated to the route: ${route.url}`);
      components = 'Global,Modal,Login';
    }

    if (route.routeConfig.path == '' || route.routeConfig.path == 'login') {
      var data =  await this.loadService.loadSiteResources();
    }

    try {
      var adpresources = await this.resourcesLoader.loadAllPageResources(components, false, this.firstLoad).toPromise();

      // Labels are MERGED, not replaced. This resolver is attached to both a parent layout route
      // and its leaf, and Angular runs those two resolvers concurrently with different `sfresources`
      // lists. `setGlobalLabels` assigns the store outright, so whichever response landed last used
      // to wipe the other's labels — e.g. the dashboard leaf (no `PlanRenewal`) overwriting the
      // parent's renewal labels, rendering raw keys like `Dashboard_Renewal_Title_Expired`.
      this.resourceService.setGlobalResources(adpresources.resources);
      this.resourceService.updateGlobalLabels(adpresources.labels);
      this.resourceService.setPortalPageList(adpresources.lists);
      this.resourceService.setGlobalResources(adpresources.resources);
      this.resourceService.updateGlobalLabels(adpresources.labels);
      this.resourceService.setPortalPageList(adpresources.lists);
      this.resourceService.setPortalList(this.resourceService.lists);
      this.resourceService.setGlobalImages(this.resourceService.images);
      this.resourceService.setGlobalSettings(this.resourceService.settings);

      this.loadService.isSiteResourcesLoaded.next(true);

      this.firstLoad = false;
    }
    catch (e) {
      console.log(e);
      return null;
    }

    const params: any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop: any) => searchParams.get(prop),
    });

    this.uriOrigin = params?.origin ? params?.origin?.toLowerCase()?.trim() : '';

    if (route.routeConfig.path == '' || route.routeConfig.path == 'login')
      return data;
    else
      return adpresources;
  }

}
